<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsSample-fabricSeriesReview',
  components: { PageTable },
}
</script>
